import * as React from "react";

export class Root extends React.Component<{modifier?: string}, {}> {
    render() {
        return (
            <table className={`rj-table ${this.props.modifier ? this.props.modifier : ""}`}>
                {this.props.children}
            </table>
        );
    }
}